import { render, staticRenderFns } from "./EvaluationQuestionTable.vue?vue&type=template&id=9befbcae&scoped=true&"
import script from "./EvaluationQuestionTable.vue?vue&type=script&lang=js&"
export * from "./EvaluationQuestionTable.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationQuestionTable.vue?vue&type=style&index=0&id=9befbcae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9befbcae",
  null
  
)

export default component.exports